import { getCurrentDay } from '../../../../../utils/date';

const getImageObj = (url = '') => ({
  thumbnail: url || '',
  image: url || '',
  created_at: getCurrentDay(),
});

export { getImageObj };
